import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
@charset "UTF-8";
:host {
  display: block;
}

.admin-page {
  color: #111827;
}

.admin-jump-nav {
  border-color: rgba(15, 23, 42, 0.08);
  background: rgba(246, 246, 243, 0.94);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.04), 0 12px 28px rgba(15, 23, 42, 0.045);
  -webkit-overflow-scrolling: touch;
}

.admin-tab {
  color: #68686d;
}

.admin-tab.is-active {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.1), 0 5px 14px rgba(15, 23, 42, 0.045);
}

.admin-overview-grid > article,
.admin-section {
  border-color: rgba(15, 23, 42, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.04), 0 18px 42px rgba(15, 23, 42, 0.05);
}

.admin-bulk-controls {
  border-bottom: 1px solid #ececea;
  background: #fbfbfa;
}

.admin-bulk-summary {
  display: flex;
  min-height: 4rem;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 1rem;
}

.admin-bulk-summary strong,
.admin-bulk-summary > div > span {
  display: block;
}

.admin-bulk-summary strong {
  color: #111827;
  font-size: 0.75rem;
  font-weight: 900;
}

.admin-bulk-summary > div > span {
  margin-top: 0.12rem;
  color: #8e8e93;
  font-size: 0.6875rem;
  font-weight: 700;
}

.admin-bulk-current {
  border: 1px solid #e4e4e1;
  border-radius: 999px;
  background: #fff;
  padding: 0.3rem 0.55rem;
  color: #68686d !important;
  font-size: 0.625rem !important;
  font-weight: 900 !important;
  white-space: nowrap;
}

.admin-bulk-chevron {
  color: #68686d;
  font-size: 0.75rem;
  transition: transform 0.16s ease;
}

.admin-bulk-controls[open] .admin-bulk-chevron {
  transform: rotate(180deg);
}

.admin-bulk-body {
  border-top: 1px solid #ececea;
  background: #f7f7f5;
}

.admin-bulk-section {
  padding: 1rem;
}

.admin-bulk-section + .admin-bulk-section {
  border-top: 1px solid #e7e7e4;
}

.admin-risk-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.admin-preset-card:hover,
.admin-risk-grid button:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
}

.admin-filter-description {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.admin-filter-analysis {
  margin-top: 0.45rem;
}

.admin-filter-analysis > summary {
  display: inline-flex;
  min-height: 2rem;
  cursor: pointer;
  list-style: none;
  align-items: center;
  color: #68686d;
  font-size: 0.6875rem;
  font-weight: 900;
}

.admin-filter-analysis > summary::after {
  margin-left: 0.35rem;
  content: "▾";
  transition: transform 0.16s ease;
}

.admin-filter-analysis[open] > summary::after {
  transform: rotate(180deg);
}

.admin-filter-analysis-body {
  border-radius: 0.65rem;
  background: #f3f3f0;
  padding: 0.55rem 0.65rem;
  color: #8e8e93;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.65;
}

.admin-filter-analysis-body p + p,
.admin-filter-analysis-body p + div {
  margin-top: 0.25rem;
}

details > summary::-webkit-details-marker {
  display: none;
}

@media (max-width: 359px) {
  .admin-jump-nav {
    gap: 0.125rem;
    padding: 0.25rem;
  }
}
@media (min-width: 640px) {
  .admin-bulk-summary,
  .admin-bulk-section {
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }
  .admin-risk-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (prefers-reduced-motion: reduce) {
  .admin-bulk-chevron,
  .admin-filter-analysis > summary::after,
  .admin-preset-card,
  .admin-risk-grid button {
    transition: none;
  }
}`],
})
export class PageAdminComponent implements OnInit {
    public loading: boolean = true;
    public loadError: string = '';
    public syncing: boolean = false;
    public probabilityBuilding: boolean = false;
    public summary: any = {};
    public latestDraw: any = null;
    public latestSync: any = null;
    public syncRuns: any[] = [];
    public syncRunLimit: number = 3;
    public showAllSyncRuns: boolean = false;
    public schedulerRunning: boolean = false;
    public schedulerStatus: any = {};
    public probabilitySchedulerRunning: boolean = false;
    public probabilitySchedulerStatus: any = {};
    public generationPolicy: any = null;
    public strategy: any = { profiles: [], profile: null };
    public filters: any = {
        modules: [],
        categories: [],
        risk_levels: [],
        presets: [],
        enabled_modules: [],
        effective_modules: []
    };
    public togglingFilterKey: string = '';
    public togglingCategoryKey: string = '';
    public togglingRiskLevel: string = '';
    public applyingPresetKey: string = '';
    public applyingStrategyProfileKey: string = '';
    public currentTime: string = '';
    public signalQuery: string = '';
    public signalStatus: 'all' | 'enabled' | 'disabled' = 'all';
    public activeAdminSection: 'overview' | 'strategy' | 'signals' | 'sync' = 'overview';
    public openCategoryKeys: string[] = [];
    private readonly categoryStorageKey = 'newlife.admin.open_signal_categories';

    constructor(@Inject( Service) public service: Service) { }

    private normalizeFilters(value: any) {
        const filters = value || { modules: [] };
        filters.modules = filters.modules || [];
        filters.categories = filters.categories || [];
        filters.risk_levels = filters.risk_levels || [];
        filters.presets = filters.presets || [];
        filters.active_preset = filters.presets.find(
            (preset: any) => !!preset.active
        ) || null;
        filters.enabled_modules = filters.modules.filter(
            (module: any) => !!module.enabled
        );
        filters.effective_modules = filters.modules.filter(
            (module: any) => !!module.runtime_effective
        );
        return filters;
    }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        if (this.service.auth.session?.role !== 'admin') {
            location.href = '/dashboard';
            return;
        }
        this.restoreCategoryState();
        await this.load();
    }

    private restoreCategoryState() {
        try {
            const stored = JSON.parse(localStorage.getItem(this.categoryStorageKey) || '[]');
            this.openCategoryKeys = Array.isArray(stored)
                ? stored.filter((key: any) => typeof key === 'string')
                : [];
        } catch (_error) {
            this.openCategoryKeys = [];
        }
    }

    private saveCategoryState() {
        try {
            localStorage.setItem(this.categoryStorageKey, JSON.stringify(this.openCategoryKeys));
        } catch (_error) {
            // 저장 공간을 사용할 수 없는 환경에서도 관리자 기능은 그대로 동작한다.
        }
    }

    public hasSignalFilters() {
        return !!this.signalQuery.trim() || this.signalStatus !== 'all';
    }

    public setSignalQuery(value: string) {
        this.signalQuery = String(value || '');
    }

    public setSignalStatus(status: 'all' | 'enabled' | 'disabled') {
        this.signalStatus = status;
    }

    public clearSignalFilters() {
        this.signalQuery = '';
        this.signalStatus = 'all';
    }

    private moduleMatches(module: any) {
        const enabledMatches = this.signalStatus === 'all'
            || (this.signalStatus === 'enabled' && !!module?.enabled)
            || (this.signalStatus === 'disabled' && !module?.enabled);
        if (!enabledMatches) return false;

        const query = this.signalQuery.trim().toLocaleLowerCase('ko-KR');
        if (!query) return true;
        const text = [
            this.signalName(module),
            module?.description,
            module?.risk_name,
            module?.filter_key
        ].filter(Boolean).join(' ').toLocaleLowerCase('ko-KR');
        return text.includes(query);
    }

    public visibleModules(category: any) {
        return (category?.modules || []).filter((module: any) => this.moduleMatches(module));
    }

    public visibleCategories() {
        return (this.filters?.categories || []).filter(
            (category: any) => this.visibleModules(category).length > 0
        );
    }

    public visibleSignalCount() {
        return this.visibleCategories().reduce(
            (count: number, category: any) => count + this.visibleModules(category).length,
            0
        );
    }

    public isCategoryOpen(category: any) {
        return this.hasSignalFilters()
            || this.openCategoryKeys.includes(category?.category_key);
    }

    public rememberCategoryState(category: any, event: Event) {
        if (this.hasSignalFilters()) return;
        const key = category?.category_key;
        if (!key) return;
        const isOpen = !!(event.target as HTMLDetailsElement)?.open;
        const keys = new Set(this.openCategoryKeys);
        isOpen ? keys.add(key) : keys.delete(key);
        this.openCategoryKeys = Array.from(keys);
        this.saveCategoryState();
    }

    public async selectAdminSection(section: 'overview' | 'strategy' | 'signals' | 'sync') {
        this.activeAdminSection = section;
        await this.service.render();
        const root = document.querySelector('app-root');
        if (root) root.scrollTo({ top: 0, behavior: 'auto' });
    }

    public async handleAdminTabKey(event: KeyboardEvent) {
        const sections: Array<'overview' | 'strategy' | 'signals' | 'sync'> = [
            'overview', 'strategy', 'signals', 'sync'
        ];
        const currentIndex = sections.indexOf(this.activeAdminSection);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % sections.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + sections.length) % sections.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = sections.length - 1;
        else return;

        event.preventDefault();
        const nextSection = sections[nextIndex];
        await this.selectAdminSection(nextSection);
        document.getElementById('admin-tab-' + nextSection)?.focus();
    }

    public trackByCategoryKey(_index: number, category: any) {
        return category?.category_key;
    }

    public trackByFilterKey(_index: number, module: any) {
        return module?.filter_key;
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('overview');
            if (code === 403) {
                location.href = '/dashboard';
                return;
            }
            if (code !== 200) {
                this.loadError = data.message || '관리자 화면을 불러오지 못했습니다.';
                return;
            }
            this.summary = data.summary || {};
            this.latestDraw = data.latest_draw;
            this.latestSync = data.latest_sync;
            this.syncRuns = data.sync_runs || [];
            this.schedulerRunning = !!data.scheduler_running;
            this.schedulerStatus = data.scheduler_status || {};
            this.probabilitySchedulerRunning = !!data.probability_scheduler_running;
            this.probabilitySchedulerStatus = data.probability_scheduler_status || {};
            this.generationPolicy = data.generation_policy;
            this.filters = this.normalizeFilters(data.filters);
            this.strategy = data.strategy || { profiles: [], profile: null };
            this.currentTime = data.current_time || '';
        } catch (error) {
            this.loadError = '연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async requestSync(run: any = null) {
        if (this.syncing) return;
        const retrying = !!run;
        const confirmed = await this.service.modal.show({
            title: retrying ? '실패한 업데이트 다시 시도' : '공식 결과 업데이트',
            message: retrying
                ? '선택한 실패 기록부터 공식 결과를 다시 확인할까요?'
                : '동행복권의 공식 결과를 지금 다시 확인할까요?',
            cancel: true,
            action: retrying ? '다시 시도' : '지금 확인',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.syncing = true;
        await this.service.render();

        let code = 0;
        let data: any = {};
        try {
            const response = await wiz.call('run_sync', {
                retry_of_run_id: run?.id || ''
            });
            code = response.code;
            data = response.data || {};
        } catch (error) {
            data = {
                message: '업데이트 결과를 확인하지 못했습니다. 기록을 새로고침해주세요.'
            };
        } finally {
            this.syncing = false;
            await this.load();
        }

        if (code === 200) {
            await this.service.modal.success(
                data.result?.message || '공식 결과 업데이트를 완료했습니다.'
            );
        } else {
            await this.service.modal.error(
                data.message || '공식 결과를 업데이트하지 못했습니다.'
            );
        }
        await this.service.render();
    }

    public async rebuildProbability() {
        if (this.probabilityBuilding) return;
        const confirmed = await this.service.modal.show({
            title: '전체 조합 다시 계산',
            message: '최신 당첨번호를 기준으로 전체 조합 8,145,060개를 다시 계산할까요? 번호 생성은 계속 이용할 수 있습니다.',
            cancel: true,
            action: '계산 시작',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.probabilityBuilding = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('rebuild_probability');
            if (code !== 202) {
                await this.service.modal.error(
                    data.message || '전체 조합 계산을 시작하지 못했습니다.'
                );
                return;
            }
            await this.service.modal.success(
                '계산을 시작했습니다. 끝나기 전에는 현재 사용 중인 방식으로 번호를 만듭니다.'
            );
            await this.load();
        } catch (_error) {
            await this.service.modal.error('전체 조합 계산을 시작했는지 확인하지 못했습니다.');
        } finally {
            this.probabilityBuilding = false;
            await this.service.render();
        }
    }

    public visibleSyncRuns() {
        return this.showAllSyncRuns
            ? this.syncRuns
            : this.syncRuns.slice(0, this.syncRunLimit);
    }

    public hiddenSyncRunCount() {
        return Math.max(0, this.syncRuns.length - this.syncRunLimit);
    }

    public async toggleSyncHistory() {
        this.showAllSyncRuns = !this.showAllSyncRuns;
        await this.service.render();
    }

    public async toggleFilter(module: any) {
        if (this.togglingFilterKey || this.togglingCategoryKey || this.togglingRiskLevel || this.applyingPresetKey || this.applyingStrategyProfileKey) return;
        const nextEnabled = !module.enabled;
        const confirmed = await this.service.modal.show({
            title: nextEnabled ? '제외 필터 켜기' : '제외 필터 끄기',
            message: nextEnabled
                ? this.signalName(module) + ' 조건에 맞는 조합을 생성 대상에서 제외할까요?'
                : this.signalName(module) + ' 조건의 제외를 중단할까요?',
            cancel: true,
            action: nextEnabled ? '켜기' : '끄기',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.togglingFilterKey = module.filter_key;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('toggle_filter', {
                filter_key: module.filter_key,
                enabled: nextEnabled
            });
            if (code === 200) {
                this.filters = this.normalizeFilters(data.filters);
                this.strategy = data.strategy || this.strategy;
                await this.service.modal.success(
                    nextEnabled ? '제외 필터를 켰습니다.' : '제외 필터를 껐습니다.'
                );
                return;
            }
            await this.service.modal.error(
                data.message || '필터 상태를 변경하지 못했습니다.'
            );
        } catch (error) {
            await this.service.modal.error(
                '필터 변경 결과를 확인하지 못했습니다. 다시 확인해주세요.'
            );
        } finally {
            this.togglingFilterKey = '';
            await this.service.render();
        }
    }

    public async toggleCategory(category: any) {
        if (this.togglingFilterKey || this.togglingCategoryKey || this.togglingRiskLevel || this.applyingPresetKey || this.applyingStrategyProfileKey) return;
        const nextEnabled = !category.all_enabled;
        const confirmed = await this.service.modal.show({
            title: nextEnabled ? '분류 필터 모두 켜기' : '분류 필터 모두 끄기',
            message: category.name + '의 ' + category.module_count
                + '개 필터를 모두 ' + (nextEnabled ? '켤까요?' : '끌까요?'),
            cancel: true,
            action: nextEnabled ? '모두 켜기' : '모두 끄기',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.togglingCategoryKey = category.category_key;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('toggle_filter_category', {
                category_key: category.category_key,
                enabled: nextEnabled
            });
            if (code === 200) {
                this.filters = this.normalizeFilters(data.filters);
                this.strategy = data.strategy || this.strategy;
                await this.service.modal.success(
                    nextEnabled
                        ? '이 분류의 필터를 모두 켰습니다.'
                        : '이 분류의 필터를 모두 껐습니다.'
                );
                return;
            }
            await this.service.modal.error(
                data.message || '분류별 필터를 변경하지 못했습니다.'
            );
        } catch (error) {
            await this.service.modal.error(
                '분류별 필터 변경 결과를 확인하지 못했습니다.'
            );
        } finally {
            this.togglingCategoryKey = '';
            await this.service.render();
        }
    }

    public async toggleRisk(risk: any) {
        if (this.togglingFilterKey || this.togglingCategoryKey || this.togglingRiskLevel || this.applyingPresetKey || this.applyingStrategyProfileKey) return;
        const nextEnabled = !risk.all_enabled;
        const confirmed = await this.service.modal.show({
            title: nextEnabled ? risk.name + ' 전체 적용' : risk.name + ' 전체 해제',
            message: risk.name + ' 필터 ' + risk.module_count + '개를 모두 '
                + (nextEnabled ? '켤까요?' : '끌까요?'),
            cancel: true,
            action: nextEnabled ? '모두 켜기' : '모두 끄기',
            actionBtn: risk.risk_level === 'aggressive' || risk.risk_level === 'experimental'
                ? 'error'
                : 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.togglingRiskLevel = risk.risk_level;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('toggle_filter_risk', {
                risk_level: risk.risk_level,
                enabled: nextEnabled
            });
            if (code === 200) {
                this.filters = this.normalizeFilters(data.filters);
                this.strategy = data.strategy || this.strategy;
                await this.service.modal.success(
                    nextEnabled
                        ? risk.name + ' 필터를 모두 켰습니다.'
                        : risk.name + ' 필터를 모두 껐습니다.'
                );
                return;
            }
            await this.service.modal.error(
                data.message || '위험 수준별 필터를 변경하지 못했습니다.'
            );
        } catch (error) {
            await this.service.modal.error(
                '위험 수준별 필터 변경 결과를 확인하지 못했습니다.'
            );
        } finally {
            this.togglingRiskLevel = '';
            await this.service.render();
        }
    }

    public async applyPreset(preset: any) {
        if (preset.active || this.togglingFilterKey || this.togglingCategoryKey
            || this.togglingRiskLevel || this.applyingPresetKey
            || this.applyingStrategyProfileKey) return;
        const confirmed = await this.service.modal.show({
            title: preset.name + ' 적용',
            message: preset.module_count + '개 필터로 다시 설정합니다. 현재 필터 설정은 이 빠른 설정으로 바뀝니다.',
            cancel: true,
            action: '적용',
            actionBtn: preset.preset_key === 'strong' ? 'error' : 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.applyingPresetKey = preset.preset_key;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('apply_filter_preset', {
                preset_key: preset.preset_key
            });
            if (code === 200) {
                this.filters = this.normalizeFilters(data.filters);
                this.strategy = data.strategy || this.strategy;
                await this.service.modal.success(
                    preset.name + ' 빠른 설정을 적용했습니다.'
                );
                return;
            }
            await this.service.modal.error(
                data.message || '필터 빠른 설정을 적용하지 못했습니다.'
            );
        } catch (error) {
            await this.service.modal.error(
                '빠른 설정 적용 결과를 확인하지 못했습니다. 다시 확인해주세요.'
            );
        } finally {
            this.applyingPresetKey = '';
            await this.service.render();
        }
    }

    public async applyStrategyProfile(profile: any) {
        if (profile.active || this.applyingStrategyProfileKey
            || this.togglingFilterKey || this.togglingCategoryKey
            || this.togglingRiskLevel || this.applyingPresetKey) return;
        const confirmed = await this.service.modal.show({
            title: profile.name + ' 적용',
            message: '기본 무작위 ' + profile.uniform_weight_percent + '%, 지난 기록 참고 '
                + profile.history_weight_percent + '%, 인기 번호 피하기 '
                + profile.crowd_weight_percent + '%로 변경할까요?',
            cancel: true,
            action: '적용',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.applyingStrategyProfileKey = profile.profile_key;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('apply_strategy_profile', {
                profile_key: profile.profile_key
            });
            if (code === 200) {
                this.strategy = data.strategy || this.strategy;
                await this.service.modal.success(profile.name + '을 적용했습니다.');
                return;
            }
            await this.service.modal.error(
                data.message || '생성 전략을 적용하지 못했습니다.'
            );
        } catch (error) {
            await this.service.modal.error('번호 생성 방식 변경 결과를 확인하지 못했습니다.');
        } finally {
            this.applyingStrategyProfileKey = '';
            await this.service.render();
        }
    }

    public statusLabel(status: string) {
        const labels: any = {
            success: '새 결과 저장',
            no_new_data: '최신 확인',
            failed: '실패',
            running: '진행 중'
        };
        return labels[status] || status || '-';
    }

    public signalName(module: any) {
        return String(module?.name || '');
    }

    public statusClass(status: string) {
        const classes: any = {
            success: 'bg-emerald-100 text-emerald-700',
            no_new_data: 'bg-blue-100 text-blue-700',
            failed: 'bg-red-100 text-red-700',
            running: 'bg-amber-100 text-amber-800'
        };
        return classes[status] || 'bg-slate-100 text-slate-600';
    }

    public triggerLabel(run: any) {
        if (run?.requested_by_user_id) {
            return run.retry_of_run_id ? '관리자 다시 시도' : '관리자 실행';
        }
        const labels: any = {
            scheduled: '자동',
            request: '빠진 결과 보완',
            manual: '수동'
        };
        return labels[run?.trigger_type] || run?.trigger_type || '-';
    }

    public displayTime(value: any) {
        if (!value) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(new Date(value));
    }

    public duration(run: any) {
        if (run?.duration_seconds === null || run?.duration_seconds === undefined) {
            return run?.status === 'running' ? '진행 중' : '-';
        }
        return Number(run.duration_seconds).toFixed(1) + '초';
    }
}

export default PageAdminComponent;